import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FileDashboardData } from '../models/fileDashboard-data.model';
import { DisplayApplicationData } from '../models/displayApplication-data.model';
import { DisplayFacilityData } from '../models/displayfacility-data.model';
import { DisplaySurgeonData } from '../models/displaySurgeon-data.model';
import { UploadErrorData } from '../models/displayUploadError-data.model';
import { FileDetailsData } from '../models/fileDetails-data.model';
import { LoginData } from '../models/login.model';
import { UploadData } from '../models/upload-data.model';
import { AuditLogExportData, LoggedUserDetails, PopupCancelData, SnnFacilityData } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
/**
  * Class Name: SharedStateService
  * Description: This state service is used to share local datas from one component to other component ....
  * Author : Brinda Durai
**/
export class SharedStateService {
  uploadState = new UploadData();
  uploadStateSubject = new BehaviorSubject(this.uploadState)
  uploadStateData$: Observable<UploadData>;
  facilityState = new DisplayFacilityData();
  facilityStateSubject = new BehaviorSubject(this.facilityState)
  facilityStateData$: Observable<DisplayFacilityData>;
  surgeonState = new DisplaySurgeonData();
  surgeonStateSubject = new BehaviorSubject(this.surgeonState)
  surgeonStateData$: Observable<DisplaySurgeonData>;
  applicationState = new DisplayApplicationData();
  applicationStateSubject = new BehaviorSubject(this.applicationState)
  applicationStateData$: Observable<DisplayApplicationData>;
  uploadFailedState =  new UploadErrorData();
  uploadFailedStateSubject = new BehaviorSubject(this.uploadFailedState)
  uploadFailedStateData$: Observable<UploadErrorData>;
  loginState = new LoginData();
  loginStateSubject = new BehaviorSubject(this.loginState)
  loginStateData$: Observable<LoginData>;
  userDetails: LoggedUserDetails;
  errUserDetails: string;
  role: string;
  imageurl: string;
  surgeonObjectState = new DisplaySurgeonData();
  surgeonObjectStateSubject = new BehaviorSubject(this.surgeonObjectState)
  surgeonObjectStateData$: Observable<DisplaySurgeonData>;
  applicationIdState = new DisplayApplicationData();
  applicationIdStateSubject = new BehaviorSubject(this.applicationIdState)
  applicationIdStateData$: Observable<DisplayApplicationData>;
  // // dicomState = new DicomData();
  // dicomStateSubject = new BehaviorSubject(this.dicomState)
  // dicomStateData$: Observable<DicomData>;
  uploadedFileState = new FileDetailsData();
  uploadedFileStateSubject = new BehaviorSubject(this.uploadedFileState)
  uploadedFileStateData$: Observable<FileDetailsData>;
  fileDashboardState = new FileDashboardData();
  fileDashboardStateSubject = new BehaviorSubject(this.fileDashboardState)
  fileDashboardStateData$: Observable<FileDashboardData>;
  popupCancelState = new PopupCancelData();
  popupCancelStateSubject = new BehaviorSubject(this.popupCancelState)
  popupCancelStateData$: Observable<PopupCancelData>;
  snnFacilityState = new SnnFacilityData();
  userActionState = new AuditLogExportData();
  userActionStateSubject = new BehaviorSubject(this.userActionState)
  userActionStateData$: Observable<AuditLogExportData>;
  ssmIdleTimeSubject = new BehaviorSubject<string>('');
  ssmIdleTimeData$: Observable<any>;
  timeOutsubject = new Subject<any>();
  timeOutCallbacsubject = new Subject<any>();
  _isImageProcessedNew$ = new BehaviorSubject<any>(undefined);
  _originalMaskBlobNew$ = new BehaviorSubject<any>(undefined);
  _updatedMaskBlobNew$ = new BehaviorSubject<any>(undefined);
  idleTimeout$ = new BehaviorSubject<string>('');
  idleTimeoutListener$: Observable<string>;

  constructor(
  ) { 
    this.uploadStateData$ = this.uploadStateSubject.asObservable();
    this.facilityStateData$=this.facilityStateSubject.asObservable();
    this.surgeonStateData$=this.surgeonStateSubject.asObservable();
    this.applicationStateData$=this.applicationStateSubject.asObservable();
    this.uploadFailedStateData$=this.uploadFailedStateSubject.asObservable();
    this.loginStateData$ = this.loginStateSubject.asObservable();
    this.surgeonObjectStateData$=this.surgeonObjectStateSubject.asObservable();
    this.applicationIdStateData$=this.applicationIdStateSubject.asObservable();
    // this.dicomStateData$ = this.dicomStateSubject.asObservable();
    this.uploadedFileStateData$ = this.uploadedFileStateSubject.asObservable();
    this.fileDashboardStateData$ = this.fileDashboardStateSubject.asObservable();
    this.popupCancelStateData$ = this.popupCancelStateSubject.asObservable();
    this.userActionStateData$ = this.userActionStateSubject.asObservable();
    this.ssmIdleTimeData$ = this.ssmIdleTimeSubject.asObservable();
    this.idleTimeoutListener$ = this.idleTimeout$.asObservable();
  }

  setDashboardStateData(data: any){
    this.uploadStateSubject.next(data);
  }

  facilitySelectionData(data:any){
    this.facilityStateSubject.next(data);
  }

  surgeonSelectionData(data:any){
    this.surgeonStateSubject.next(data);
  }

  applicationSelectionData(data:any){
    this.applicationStateSubject.next(data);
  }

  uploadFailedData(data:any){
    this.uploadStateSubject.next(data);
  }

  setLoginStateData(data: any){
    this.loginStateSubject.next(data);
  }

  surgeonObjectData(data:any){
    this.surgeonObjectStateSubject.next(data);
  }

  applicationIdData(data:any){
    this.applicationIdStateSubject.next(data);
  }
  
  // setDicomStateData(data: any){
  //   this.dicomStateSubject.next(data);
  // }

  uploadedFileDetails(data:any){
    this.uploadedFileStateSubject.next(data);
  }

  displayDashboardError(data: any){
    this.fileDashboardStateSubject.next(data);
  }

  popupCancelData(data: any){
    this.popupCancelStateSubject.next(data);
  }
  
  userActionDetails(data: any){
    this.userActionStateSubject.next(data);
  }
  ssmIdleTimeVal(data: any){
    this.ssmIdleTimeSubject.next(data);
  }

  idleTimeout(data: string) {
    this.idleTimeout$.next(data);
  }

  idleTimeoutUnsubscribe() {
    this.idleTimeout$.unsubscribe();
  }
}
